import React from 'react';
import { NurseryHeader, TabNavigation } from '../components';
import { useAppSelector } from '../services/store';
import { getShowDownloadAppBanner } from 'src/shared/redux-state/src';
import { useWindowWidth } from '../utilities/helpers';

interface NurseryLayoutProps {
    children: React.ReactNode;
    fixedFooter?: boolean;
    showFilter?: boolean
}

const NurseryLayout = ({ children, fixedFooter = false, showFilter }: NurseryLayoutProps) => {
    
    const showDownloadAppBanner = useAppSelector(getShowDownloadAppBanner);
    const width = useWindowWidth();

    return (
        <div className={`main-wrapper bg-white container ${showDownloadAppBanner ? (width > 567 ? 'pd-t-86' : 'pd-t-92') : 'pd-t-50'} ${fixedFooter ? 'pd-b-70' : 'pd-b-20'}`}>
            <NurseryHeader showFilter={showFilter}/>
            {children}
            <TabNavigation />
        </div>
    );
};

export default NurseryLayout;
